<div class="flex flex-col gap-4" *transloco="let t">
  <p>
    {{
      t("remove-audience-popup.delete_confirm", [
        modalData.audience.expressionType,
        modalData.audience.matchType,
        modalData.audience.lookback,
      ])
    }}
  </p>
</div>
<div class="flex justify-end gap-2" *transloco="let t">
  <IButton label="{{ t('common.cancel') }}" color="gray" variant="ghost" (onClick)="modalRef.close()" />
  <IButton label="{{ t('common.delete') }}" color="red" (onClick)="delete()" />
</div>
